<script setup lang="ts">
import { useStore } from 'vuex'
import { IS_SETTINGS_PAGE } from '@/store/mutation-types'
import {
  loadAuthorisationPageData,
  useDashboardPageLoad,
} from '@/composables/useDashboardPageLoad'
import MatchingPageSkeleton from '@/components/dashboard/ui/MatchingPageSkeleton.vue'
import StatusAuthorisationHero from '@/components/dashboard/status/StatusAuthorisationHero.vue'
import GiftAidMatchingSection from '@/components/dashboard/matching/GiftAidMatchingSection.vue'
import AccountPlanSection from '@/components/dashboard/account/AccountPlanSection.vue'
import AccountCloseAccountFooter from '@/components/dashboard/account/AccountCloseAccountFooter.vue'
import StatusLegalSection from '@/components/dashboard/status/StatusLegalSection.vue'

const store = useStore()

const { isPageLoading } = useDashboardPageLoad(async () => {
  await loadAuthorisationPageData(store, async () => {
    store.commit(IS_SETTINGS_PAGE, true)
  })
})
</script>

<template>
  <div class="sa-stack" role="main">
    <MatchingPageSkeleton v-if="isPageLoading" />

    <template v-else>
      <StatusAuthorisationHero />
      <GiftAidMatchingSection />
      <AccountPlanSection />
      <StatusLegalSection />
      <AccountCloseAccountFooter />
    </template>
  </div>
</template>
